import { useState } from 'react';
import { Drawer } from 'antd';
import { useDispatch, useSelector } from 'react-redux';

import { setDrawerState } from '../../../reducers/Drawer/actions';
import { FILTERS_DRAWER } from '../../../reducers/Drawer/types';
import { deleteAppliedFilter } from '../../../reducers/Filters/actions';
import { InitialFiltersState } from './Components/InitialFiltersState';
import { FiltersBuilder } from './Components/FiltersBuilder';
import { FilterList } from './Components/FilterList';
import { REPORT_FILTER_CONFIG } from './constants';
import { ZorbaButton, ZorbaInput } from '../../../components/forms';
import { BUTTON_VARIANT_DARK } from '../../../components/forms/ZorbaButton/constants';
import { useCreateView } from '../../../queries/View';
import { setDefaultView } from '../../../reducers/Auth/actions';

import './index.scss';

export const FiltersDrawer = ({
  createViewMode,
  setCreateViewMode,
  availableFilters = [],
}) => {
  const dispatch = useDispatch();
  const [showFilterList, setShowFilterList] = useState(false);
  const [selectedCustomFilter, setSelectedCustomFilter] = useState('');
  const { appliedFilters: storedAppliedFilters } = useSelector(
    ({ FiltersReducer }) => FiltersReducer,
  );
  const appliedFilters = availableFilters.length
    ? Object.fromEntries(
        Object.entries(storedAppliedFilters).filter(([key]) =>
          availableFilters.includes(key),
        ),
      )
    : storedAppliedFilters;

  const [viewName, setViewName] = useState('');
  const handleDrawerClose = () => {
    dispatch(setDrawerState(FILTERS_DRAWER, false));
    setSelectedCustomFilter('');
    setShowFilterList(false);
    setCreateViewMode(false);
    setViewName('');
  };
  const { isFiltersDrawerOpen } = useSelector(
    ({ DrawerReducer }) => DrawerReducer,
  );

  const handleFilterListBack = () => {
    setShowFilterList(false);
  };

  const selectFilter = (value) => {
    setSelectedCustomFilter(value);
    setShowFilterList(false);
  };

  const handleOpenFilterList = () => {
    setShowFilterList(true);
  };

  const filterConfig = availableFilters.length
    ? REPORT_FILTER_CONFIG.filter(
        (filter) =>
          availableFilters.some(
            (availableFilter) => availableFilter === filter.value,
          ) &&
          !Object.keys(appliedFilters).some(
            (appliedFilter) => appliedFilter === filter.value,
          ),
      )
    : REPORT_FILTER_CONFIG.filter(
        (filter) =>
          !Object.keys(appliedFilters).some(
            (appliedFilter) => appliedFilter === filter.value,
          ),
      );
  const handleFilterBuilderBack = () => {
    if (filterConfig.length) {
      setShowFilterList(true);
      setSelectedCustomFilter('');
    } else {
      setSelectedCustomFilter('');
    }
  };

  const onApplyFilter = () => {
    setShowFilterList(false);
    setSelectedCustomFilter('');
  };

  const handleOpenFilterDetail = (filterKey) => {
    setSelectedCustomFilter(filterKey);
    setShowFilterList(false);
  };

  const handleOnDelete = (filterKey) => {
    dispatch(deleteAppliedFilter(filterKey));
  };

  const { query, ...filtersToApply } = appliedFilters;

  const handleSuccess = (viewId) => {
    handleDrawerClose();
    dispatch(setDefaultView(viewId));
  };

  const { mutate: createView, isPending } = useCreateView(handleSuccess);

  const handleCreateWatchList = () => {
    createView({ viewName, appliedFilters });
  };

  return (
    <Drawer
      className="top-buyers-report-filters-drawer"
      width={420}
      title="All filters"
      placement="right"
      onClose={handleDrawerClose}
      open={isFiltersDrawerOpen}
    >
      {createViewMode && (
        <div className="view-name-container">
          <ZorbaInput
            label="View name"
            placeholder="Vacant lots in Florida"
            fullWidth
            value={viewName}
            onChange={(e) => setViewName(e.target.value)}
          />
        </div>
      )}
      {!selectedCustomFilter && !showFilterList && (
        <InitialFiltersState
          handleOpenFilterList={handleOpenFilterList}
          appliedFilters={filtersToApply}
          filterConfig={filterConfig}
          handleOpenFilterDetail={handleOpenFilterDetail}
          handleOnDelete={handleOnDelete}
          availableFilters={availableFilters}
        />
      )}
      {showFilterList && (
        <FilterList
          filterConfig={filterConfig}
          handleBack={handleFilterListBack}
          selectFilter={selectFilter}
          availableFilters={availableFilters}
        />
      )}
      {selectedCustomFilter && !showFilterList && (
        <FiltersBuilder
          handleBack={handleFilterBuilderBack}
          selectedFilter={selectedCustomFilter}
          onApplyFilter={onApplyFilter}
        />
      )}
      {createViewMode && (
        <div className="create-view-button-container">
          <ZorbaButton
            fullWidth={false}
            variant={BUTTON_VARIANT_DARK}
            disabled={
              !viewName || !Object.keys(appliedFilters).length || isPending
            }
            loading={isPending}
            onClick={handleCreateWatchList}
          >
            Create
          </ZorbaButton>
        </div>
      )}
    </Drawer>
  );
};
